import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { size = 24, color = '#000', ...rest } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M6.375 8.25a.75.75 0 01.75-.75h9.75a.75.75 0 010 1.5h-9.75a.75.75 0 01-.75-.75zM6.375 11.25a.75.75 0 01.75-.75h4.125a.75.75 0 010 1.5H7.125a.75.75 0 01-.75-.75z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M2.69 2.69a1.5 1.5 0 011.06-.44h16.5a1.5 1.5 0 011.5 1.5v5.625a.75.75 0 01-1.5 0V3.75H3.75v13.037l1.915-.958a.75.75 0 01.67 0L9 17.161l1.915-.957a.75.75 0 11.67 1.342l-2.25 1.125a.75.75 0 01-.67 0L6 17.339 3.335 18.67A.75.75 0 012.25 18V3.75c0-.398.158-.78.44-1.06z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M14.949 12.75v7.5h6v-5.314l-2.186-2.186h-3.814zm-1.17-1.17c.21-.212.496-.33.795-.33h4.5a.75.75 0 01.53.22l2.625 2.625c.14.14.22.331.22.53v6a1.125 1.125 0 01-1.125 1.125h-6.75a1.125 1.125 0 01-1.125-1.125v-8.25c0-.298.118-.585.33-.796z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M19.074 11.25a.75.75 0 01.75.75v1.875h1.875a.75.75 0 010 1.5h-2.625a.75.75 0 01-.75-.75V12a.75.75 0 01.75-.75z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default Icon;
